import React, { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../redux/reducer/loginReducer";
import TituloPagina from "../../../components/Titulos/TituloPagina";
import { getCmiAntiguosAlumnos } from "../../../services/alumnos";
import {
  Box,
  Button,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  CircularProgress,
  Table,
  Link,
} from "@material-ui/core";
import { GaugeComponent } from "react-gauge-component";
import { set } from "date-fns";
import { green, grey, red, yellow } from "@material-ui/core/colors";

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function CmiAntiguosAlumnosContent() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");

  const [antiguosAlumnos, setAntiguosAlumnos] = useState([]);
  const [numAntiguosAlumnos, setNumAntiguosAlumnos] = useState(0);
  const [datosMelani, setDatosMelani] = useState([]);
  const [datosJennifer, setDatosJennifer] = useState([]);

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    setLoading(true);
    setLoadingMensaje("Cargando datos");

    const usuario_id = usuarioSeleccionado.id;

    getCmiAntiguosAlumnos({
      usuario: usuario_id,
      nombre_dato: "estadisticas",
    }).then((response) => {
      setLoading(false);
      setLoadingMensaje("");

      setAntiguosAlumnos(response.antiguos_alumnos);

      setNumAntiguosAlumnos(response.num_antiguos_alumnos);

      setDatosMelani(response.resultado.filter((item) => item.id === "9"));
      setDatosJennifer(response.resultado.filter((item) => item.id === "15" ));

    });
  }, []);


  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */

  const Contenido = () => {
    return (
      <>
        <TituloPagina titulo={"Antiguos alumnos"} />

        <Box style={{ paddingRight: 20, paddingLeft: 20 }}>
          <Divider style={{ marginBottom: 10 }} />

              {/* Indicadores generales de antiguos alumnos */}
              <Grid container spacing={1} style={{ margin: 0 }}>

                <Grid item xs={12} md={6} lg={4}>
                  <CardIndicador
                    titulo={"ANTIGUOS ALUMNOS TOTALES"}
                    valor={numAntiguosAlumnos}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <CardIndicador
                    titulo={"ANTIGUOS ALUMNOS MELANI"}
                    valor={datosMelani[0]?.alumnos?.length}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <CardIndicador
                    titulo={"ANTIGUOS ALUMNOS JENNIFER"}
                    valor={datosJennifer[0]?.alumnos?.length}
                  />
                </Grid>
              </Grid>
              
              {/* Retenciones */}
              <Grid container spacing={1} style={{ margin: 0 }}>

                <Grid item xs={12} md={6} lg={6}>
                  <CardIndicador
                    titulo={"RETENCION MELANI"}
                    valor={`${datosMelani[0]?.retencion} (${datosMelani[0]?.porcentaje_retencion}%)`}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <CardIndicador
                    titulo={"RETENCION JENNIFER"}
                    valor={`${datosJennifer[0]?.retencion} (${datosJennifer[0]?.porcentaje_retencion}%)`}
                  />
                </Grid>

              </Grid>
              
              {/* Motivos de perdida */}
              <Grid container spacing={1} style={{ margin: 0 }}>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                          MOTIVOS DE PEDIDA DE MELANI
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosMelani[0] && <TablaMotivosPerdida datos={datosMelani[0]?.alumno_motivos_perdida} datosGenerales={datosMelani[0]}/>}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                        MOTIVOS DE PEDIDA DE JENIFER
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosJennifer[0] && <TablaMotivosPerdida datos={datosJennifer[0]?.alumno_motivos_perdida} datosGenerales={datosJennifer[0]} />}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>
              
              {/* Estados */}
              <Grid container spacing={1} style={{ margin: 0 }}>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                          CONTACTADOS DE MELANI
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosMelani[0] && <TablaEstados datos={datosMelani[0]?.alumnos_estados} />}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                          CONTACTADOS DE JENIFER
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosJennifer[0] && <TablaEstados datos={datosJennifer[0]?.alumnos_estados} />}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>

              {/* Listado de usuarios */}
              <Grid container spacing={1} style={{ margin: 0 }}>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                          VENTAS ANTIGUOS ALUMNOS DE MELANI
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosMelani[0] && <TablaVentas datos={datosMelani[0]?.alumnos} comercial_id={"19"}/>}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Card style={{ marginBottom: "20px"}}>
                    <CardContent>
                      <Grid item>
                        <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
                        VENTAS ANTIGUOS ALUMNOS DE JENIFER
                        </Typography>
                        <Divider style={{ marginBottom: 10 }} />

                        {datosJennifer[0] && <TablaVentas datos={datosJennifer[0]?.alumnos} comercial_id={"115"} />}

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>

        </Box>
      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
      {loading ? (
        <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
      ) : (
        <Contenido />
      )}
    </div>
  );
}

const CardIndicador = ({titulo, valor}) => {
  return (
    <Card style={{ marginBottom: "20px"}}>
      <CardContent>
        <Grid item>
          <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
            {titulo}
          </Typography>
          <Typography variant="h3" color="textSecondary" style={{ fontWeight: "bold", textAlign: "right"}}>
            {valor}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  )
}

const TablaMotivosPerdida = ({datos, datosGenerales}) => {
  console.log(datosGenerales)
  const total = Object.values(datos).reduce((acc, valor) => {
    return acc + valor;
  }, 0);
  return (
    <TableContainer component={Paper} style={{
      width: "100%",
    }}>
      <Table>
      <TableHead>
        <TableRow>
          <TableCell>Motivo</TableCell>
          <TableCell style={{textAlign: "right"}}>Alumnos</TableCell>
          <TableCell style={{textAlign: "right"}}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(datos).map(([clave, valor]) => (
          <TableRow key={clave}>
            <TableCell>{clave}</TableCell>
            <TableCell style={{textAlign: "right"}}>{valor}</TableCell>
            <TableCell style={{textAlign: "right"}}>{ (valor * 100 / total).toFixed(2)}%</TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell></TableCell>
          <TableCell style={{textAlign: "right", fontWeight: 'bold'}}>{total} ({(total * 100 / datosGenerales?.alumnos?.length).toFixed(2)}%)</TableCell>
          <TableCell style={{textAlign: "right", fontWeight: 'bold'}}>{ (total * 100 / total).toFixed(2)}%</TableCell>
        </TableRow>
      </TableBody>
      </Table>
    </TableContainer>
  );
}

const TablaEstados = ({datos}) => {
  const total = Object.values(datos).reduce((acc, valor) => {
    return acc + valor.valor;
  }, 0);

  return (
    <TableContainer component={Paper} style={{
      width: "100%",
    }}>
      <Table>
      <TableHead>
        <TableRow>
          <TableCell>Motivo</TableCell>
          <TableCell style={{textAlign: "right"}}>Alumnos</TableCell>
          <TableCell style={{textAlign: "right"}}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(datos).map(([clave, valor]) => (
          <TableRow key={clave}>
            <TableCell>{clave}</TableCell>
            <TableCell style={{textAlign: "right"}}>{valor.valor}</TableCell>
            <TableCell style={{textAlign: "right"}}>{valor.porcentaje.toFixed(2)}%</TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell></TableCell>
          <TableCell style={{textAlign: "right", fontWeight: 'bold'}}>{total}</TableCell>
          <TableCell style={{textAlign: "right", fontWeight: 'bold'}}>{ (total * 100 / total).toFixed(2)}%</TableCell>
        </TableRow>
      </TableBody>
      </Table>
    </TableContainer>
  );
}

const TablaVentas = ({datos, comercial_id}) => {
  return (
    <TableContainer component={Paper} style={{
      width: "100%",
    }}>
      <Table>
      <TableHead>
        <TableRow>
          <TableCell>#</TableCell>
          <TableCell>Alumno</TableCell>
          <TableCell>Estado</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(datos).map(([clave, valor]) => (
          (valor.status_id === "94" || valor.status_id === "127") && valor.comercial_cuota_usuario_id === comercial_id && 
          // valor.es_nuevo_alumno === "1" && valor.es_antiguo_alumno === "1" &&
          <TableRow key={clave}>
            <TableCell><Link href={`alumnos/detalle/${valor.alumno_id}`}>{valor.alumno_id}</Link></TableCell>
            <TableCell><Link href={`alumnos/detalle/${valor.alumno_id}`}>{valor.alumno_nombre}</Link></TableCell>
            <TableCell><span style={{color: valor.status_id === "94" ? green[500] : yellow[800]}}>{valor.status_nombre}</span></TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell></TableCell>
        </TableRow>
      </TableBody>
      </Table>
    </TableContainer>
  );
}